import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import { ErrorBoundary } from "./routes/components";
import { routesSection } from "./routes/sections";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { CONFIG } from "src/global-config";

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* Global fallback title */}
      <Helmet>
        <title>{CONFIG.appName}</title>
      </Helmet>

      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
